import Pqp from "../../3x1010/Pqp.js";
import Bout from "../bout/Bout.js";
import Screen from "../screen/Screen.js";
import ItemProviders from "./ItemProviders.js";

export default class Item {
	constructor(o) {
		this.id = this.idFromName(o.name);
		this.setProps(o);
	}
	setProps(o) {
		for (let prop in o) {
			this[prop] = o[prop];
		}
	}

	idFromName(s) {
		let ret = jQuery.trim(s.toLowerCase());
		ret = Pqp.safeReplace(ret, " ", "_");
		ret = Pqp.safeReplace(ret, "'", "_");
		ret = Pqp.safeReplace(ret, ".", "");
		ret = Pqp.safeReplace(ret, ",", "");
		ret = Pqp.safeReplace(ret, "(", "_");
		ret = Pqp.safeReplace(ret, ")", "");
		ret = Pqp.safeReplace(ret, "__", "_");
		return ret;


	}

	isBook() {
		if (this.type === ItemProviders.TYPE_BOOKS) {
			return true;
		}
		return false;

	}


	isType(type) {
		if (this.type === type) {
			return true;
		}
		return false;
	}

	isArmour() {
		let a = [
			ItemProviders.TYPE_ARMOUR_ARMOURS,
			ItemProviders.TYPE_ARMOUR_LEGGINGS,
			ItemProviders.TYPE_ARMOUR_ARMS,
			ItemProviders.TYPE_ARMOUR_HELMS,
			ItemProviders.TYPE_ARMOUR_SHOES,
			ItemProviders.TYPE_ARMOUR_SHIELDS
		];
		if (a.indexOf(this.type) >= 0) {
			return true;
		}
		return false;
	}
	isWeapon() {
		let a = [
			ItemProviders.TYPE_WEAPON_AXES,
			ItemProviders.TYPE_WEAPON_HAMMERS,
			ItemProviders.TYPE_WEAPON_MACES,
			ItemProviders.TYPE_WEAPON_SPEARS,
			ItemProviders.TYPE_WEAPON_SWORDS
		];
		if (a.indexOf(this.type) >= 0) {
			return true;
		}
		return false;
	}

	isSword() {
		let a = [
			ItemProviders.TYPE_WEAPON_AXES,
			ItemProviders.TYPE_WEAPON_SWORDS
		];
		if (a.indexOf(this.type) >= 0) {
			return true;
		}
		return false;
	}

	isMace() {
		let a = [
			ItemProviders.TYPE_WEAPON_MACES,
			ItemProviders.TYPE_WEAPON_HAMMERS
		];
		if (a.indexOf(this.type) >= 0) {
			return true;
		}
		return false;
	}

	isFence() {
		let a = [
			ItemProviders.TYPE_WEAPON_SPEARS
		];
		if (a.indexOf(this.type) >= 0) {
			return true;
		}
		return false;
	}

	isJewel() {
		let a = [
			ItemProviders.TYPE_JEWEL_NECKLACES,
			ItemProviders.TYPE_JEWEL_RINGS
		];
		if (a.indexOf(this.type) >= 0) {
			return true;
		}
		return false;
	}
	isStackable() {
		return this.stackable;
	}

	getTemplate() {
		return this.template_id;
	}
	addStackQuantity(n) {
		this.stacked += n;
	}
	setStackQuantity(n) {
		this.stacked = n;
	}
	getStackQuantity() {
		return this.stacked;
	}
	isConsumable() {
		return this.consumable;
	}


	isCoin() {
		return this.type === ItemProviders.TYPE_MONEYS;
	}

	getWeight() {
		return this.weight * this.getStackQuantity();
	}

	getDescType() {
		let a = ItemProviders.ITEM_TYPE_DESCRIPTIONS;
		for (let x = 0; x < a.length; x++) {
			if (a[x].type === this.type) {
				return a[x].value;
			}
		}
		return "Item";
	}

	getDescRarity() {
		let a = ItemProviders.ITEM_RARITY_DESCRIPTIONS;
		for (let x = 0; x < a.length; x++) {
			if (a[x].rarity === this.rarity) {
				return a[x].value;
			}
		}
		return "Common";

	}

	getClassArmourName() {
		let a = ItemProviders.ITEM_ARMOUR_CLASS_DESCRIPTIONS;
		for (let x = 0; x < a.length; x++) {
			if (a[x].armour_class === this.armour_class) {
				return a[x].value;
			}
		}
		return "None";

	}

	getDescMaterial() {
		let a = ItemProviders.ITEM_MATERIAL_DESCRIPTIONS;
		for (let x = 0; x < a.length; x++) {
			if (a[x].material === this.material) {
				return a[x].value;
			}
		}
		return "N/A";

	}


	getMinimumSkillNeededForArmour() {
		if (this.armour_class === ItemProviders.ARMOUR_CLASS_LIGHT) {
			return 250;
		}
		if (this.armour_class === ItemProviders.ARMOUR_CLASS_MEDIUM) {
			return 500;
		}
		if (this.armour_class === ItemProviders.ARMOUR_CLASS_HEAVY) {
			return 500;
		}
		return 0;
	}


	use() {
		if (this.isConsumable()) {
			if (this.isBook()) {


				Bout.that.player.skills[this.player_skill] = Bout.that.player.skills[this.player_skill] + this.bonus_skill;
				Screen.that.showSkillGain(this.player_skill, Bout.that.player.skills[this.player_skill], this.bonus_skill, false);



			} else {
				Bout.that.player.water += this.water;
				if (Bout.that.player.water > Bout.that.player.max_water) {
					Bout.that.player.water = Bout.that.player.max_water;
				}
				Bout.that.player.food += this.food;
				if (Bout.that.player.food > Bout.that.player.max_food) {
					Bout.that.player.food = Bout.that.player.max_food;
				}
				Bout.that.player.hp += this.heal;
				if (Bout.that.player.hp > Bout.that.player.max_hp) {
					Bout.that.player.hp = Bout.that.player.max_hp;
				}
				Screen.that.status.update();
			}
		} else {
			console.log("TO DO - Use item.")
		}
	}

}

